export default __webpack_public_path__ + "static/media/Kitchen-Category-Banner.f2a704eb.png";